export const ARIZONA_COUNTY_SAMPLE_DATA = Object.freeze([
  Object.freeze({ county: "Apache", fips: "04001", sick_count: 1, total_count: 4 }),
  Object.freeze({ county: "Cochise", fips: "04003", sick_count: 3, total_count: 7 }),
  Object.freeze({ county: "Coconino", fips: "04005", sick_count: 5, total_count: 9 }),
  Object.freeze({ county: "Gila", fips: "04007", sick_count: 0, total_count: 3 }),
  Object.freeze({ county: "Graham", fips: "04009", sick_count: 2, total_count: 5 }),
  Object.freeze({ county: "Greenlee", fips: "04011", sick_count: 1, total_count: 2 }),
  Object.freeze({ county: "La Paz", fips: "04012", sick_count: 4, total_count: 6 }),
  Object.freeze({ county: "Maricopa", fips: "04013", sick_count: 18, total_count: 30 }),
  Object.freeze({ county: "Mohave", fips: "04015", sick_count: 7, total_count: 12 }),
  Object.freeze({ county: "Navajo", fips: "04017", sick_count: 6, total_count: 10 }),
  Object.freeze({ county: "Pima", fips: "04019", sick_count: 14, total_count: 25 }),
  Object.freeze({ county: "Pinal", fips: "04021", sick_count: 9, total_count: 15 }),
  Object.freeze({ county: "Santa Cruz", fips: "04023", sick_count: 2, total_count: 4 }),
  Object.freeze({ county: "Yavapai", fips: "04025", sick_count: 5, total_count: 11 }),
  Object.freeze({ county: "Yuma", fips: "04027", sick_count: 8, total_count: 13 }),
]);
